const defaultAntdMobilePrefix = 'adm';
export const getPrefixCls = (suffixCls, customizePrefixCls) => {
    if (customizePrefixCls) {
        return customizePrefixCls;
    }
    return suffixCls ? `${defaultAntdMobilePrefix}-`.concat(suffixCls) : defaultAntdMobilePrefix;
};
export const usePrefixCls = (tag, props) => {
    return getPrefixCls(tag, props === null || props === void 0 ? void 0 : props.prefixCls);
};
//# sourceMappingURL=usePrefixCls.js.map